import React from "react";
import PageLayout from "../components/PageLayout";

export default function Solucoes() {
  const cards = [
    {
      title: "Academia de formação",
      text: "Percursos que transformam conhecimento em competências aplicáveis no emprego e no negócio.",
      points: [
        "Cursos presenciais",
        "Turmas empresariais",
        "Avaliação prática",
      ],
    },
    {
      title: "Centro tecnológico",
      text: "Assistência, configuração e orientação para utilizar tecnologia com confiança.",
      points: ["Manutenção", "Redes e sistemas", "Produtividade digital"],
    },
    {
      title: "Centro de produção",
      text: "Uma resposta completa para documentos, materiais promocionais e comunicação impressa.",
      points: ["Design", "Impressão", "Acabamento"],
    },
  ];
  return (
    <PageLayout
      eyebrow="Soluções CENFOTEP"
      title="Diferentes competências. Uma resposta integrada."
      intro="Quando uma necessidade exige mais do que um serviço isolado, reunimos formação, tecnologia e produção num plano único, simples de acompanhar."
      sectionTitle="Soluções que se adaptam ao seu contexto"
      sectionIntro="A combinação certa depende do seu público, prazo, orçamento e resultado desejado. A nossa equipa ajuda a definir esse caminho."
      cards={cards}
      steps={[
        {
          title: "Diagnóstico",
          text: "Identificamos prioridades e limitações.",
        },
        {
          title: "Desenho",
          text: "Combinamos serviços numa proposta coerente.",
        },
        {
          title: "Implementação",
          text: "Executamos cada etapa com responsáveis definidos.",
        },
        {
          title: "Avaliação",
          text: "Analisamos resultados e próximos passos.",
        },
      ]}
    />
  );
}
